import React, { useState } from "react";
import { Dropdown, InputField, TextComponent } from "../../../../../components";
import styles from "./ProductSetup.module.css";
import { message, Upload } from "antd";
import { RiUploadCloud2Fill } from "react-icons/ri";
import { ReactComponent as DraggerIcon } from "../../../../../assets/images/dropImage.svg";
const ProductSetup = () => {
  const [productName, setProductName] = useState("");
  const [productTag, setProductTag] = useState("");
  const [shelfLife, setShelfLife] = useState("");
  const [productPricing, setProductPricing] = useState("");
  const [category, setCategory] = useState(null);
  const [description, setDescription] = useState("");
  const [batchWeight, setBatchWeight] = useState("");
  const [quantityBatch, setQuantityBatch] = useState("");
  const [finishWeight, setFinishWeight] = useState("");
  const [finishDimension, setFinishDimension] = useState("");
  const [texture, setTexture] = useState("");
  const [finalColor, setFinalColor] = useState("");
  const [QCImage, setQCImage] = useState("");

  const { Dragger } = Upload;
  const props = {
    name: "file",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        setQCImage(info.file);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  return (
    <div>
      <TextComponent text={"Basic Info"} className={styles.productHeading} />
      <div className={styles.TwoInputRow}>
        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Product Name"}
          placeholder={"French Batard Sliced"}
          value={productName}
          onChange={(e) => setProductName(e.target.value)}
        />

        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Product Tag"}
          placeholder={"French Bread"}
          value={productTag}
          onChange={(e) => setProductTag(e.target.value)}
        />
      </div>
      <div className={styles.TwoInputRow}>
        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Shelf life (Days)"}
          placeholder={"180"}
          type={"number"}
          value={shelfLife}
          onChange={(e) => setShelfLife(e.target.value)}
        />

        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Product pricing"}
          placeholder={"$500"}
          type={"number"}
          value={productPricing}
          onChange={(e) => setProductPricing(e.target.value)}
        />
      </div>
      <Dropdown
        // className={styles.inputNew}
        label={"Category"}
        value={category}
        labelStyle={{ fontSize: 18 }}
        inputStyle={{ backgroundColor: "var(--white-color)" }}
        style={{ color: "black" }}
        options={[
          {
            value: "Bread",
            id: 1,
          },
           {
            value: "General Pastry",
            id: 2,
          },
           {
            value: "Viennoiseserie",
            id: 3,
          },
           {
            value: "Component",
            id: 4,
          },
           {
            value: "Assembly Only",
            id: 5,
          },
          
        ]}
        onChange={(e) => setCategory(e)}
      />
      <TextComponent
        text={"Finished Product Specification"}
        className={styles.productHeading}
      />
      <div className={styles.ThreeInputRow}>
        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.ThreeInputNew}
          label={"Description"}
          placeholder={"light and airy with a thin crispy crust"}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.ThreeInputNew}
          label={"Batch Weight"}
          placeholder={"15Kg"}
          value={batchWeight}
          onChange={(e) => setBatchWeight(e.target.value)}
        />

        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.ThreeInputNew}
          label={"Quantity Per Batch"}
          placeholder={"12"}
          value={quantityBatch}
          type={"number"}
          onChange={(e) => setQuantityBatch(e.target.value)}
        />
      </div>
      <div className={styles.TwoInputRow}>
        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Finished Weight"}
          placeholder={"528g"}
          value={finishWeight}
          onChange={(e) => setFinishWeight(e.target.value)}
        />

        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Finished Dimensions"}
          placeholder={"20 x 10 x 9 cm"}
          value={finishDimension}
          onChange={(e) => setFinishDimension(e.target.value)}
        />
      </div>
      <div className={styles.TwoInputRow}>
        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Texture"}
          placeholder={"light interior, crispy crust"}
          value={texture}
          onChange={(e) => setTexture(e.target.value)}
        />

        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Final Color"}
          placeholder={"ffffff White"}
          value={finalColor}
          onChange={(e) => setFinalColor(e.target.value)}
        />
      </div>
      <div className={styles.dragger}>
        <TextComponent text={"QC Check"} className={styles.draggerHeading} />
        <Dragger {...props} accept=".jpg,.jpeg,.png">
          <div className={styles.draggerInner}>
            <DraggerIcon size={30} />
            <TextComponent
              className={styles.draggerText}
              text={"Drop Your Image here"}
            />
          </div>
        </Dragger>
      </div>
    </div>
  );
};

export default ProductSetup;
